const allRoutes = {
  //landing routes
  homepage: "/",
  page404: "*",
  aboutPage: "/about",
  contactPage: "/contact-us",
  allLoginPage: "/user-login",
  allRegisterPage: "/user-register",

  //exam cell
  examCellLogin: "/exam-cell-login",
  examCellDashboard: "/exam-cell-dashboard",
  examCellUpdateStudentList: "/exam-cell-update-students-list",
  examCellUpdateStudentExcelList: "/exam-cell-update-students-excel",
  examCellEditStudent: "/exam-cell/edit-student-record",

  //common routes
  commonContactUs: "common/contact-us",
  commonThankyou: "/thank-you",

  //Student routes
  studentLogin: "/student/login",
  studentRegister: "/student/register",
  studentForgotPassword: "/student/forget-password",
  studentResetPassword: "/student/reset-password",
  studentDashboard: "/student/dashboard",
  studentProfile: "/student/profile",
  studentAchievements: "/student/achievements",
  studentAcademic: "/student/academic",
  studentCounselling: "/student/counselling",
  studentAllSemesterDetails: "/student/all-semester-details",
  studentMessage: "/student/messages",
  studentAllMessages: "/student/all-messages",
  studentReplyMessage: "/student/reply-to-message",

  //Mentor routes
  mentorLogin: "/mentor/login",
  mentorRegister: "/mentor/register",
  mentorForgotPassword: "/mentor/forget-password",
  mentorResetPassword: "/mentor/reset-password",
  mentorDashboard: "/mentor/dashboard",
  mentorProjectDetails: "/mentor/project-details",
  mentorProfile: "/mentor/profile",
  mentorStudentSection: "/mentor/students",
  mentorAddParents: "/mentor/add-parent-details",
  mentorMessage: "/mentor/messages",
  StuMessage: "/mentor/StuMessage",
  ParentMessage: "/mentor/ParentMessage",
  mentorCounselling: "/mentor/counselling",
  mentorViewStudent: "/mentor/view-student-record",
  mentorViewCounselling: "/mentor/view-student-counselling",
  mentorAllCounselllings: "/mentor/all-counsellings",

  //Class-CC routes
  ccLogin: "/class-cc/login",
  ccRegister: "/class-cc/register",
  ccForgotPassword: "/class-cc/forget-password",
  ccResetPassword: "/class-cc/reset-password",
  ccDashboard: "/class-cc/dashboard",
  ccProfile: "/class-cc/profile",
  ccMessage: "/class-cc/messages",
  ccCounselling: "/class-cc/counselling",
  ccCounsellingEmail: "/class-cc/counselling/:email",
  ccStudentSection: "/class-cc/students",
  ccMentorSection: "/class-cc/mentors",
  ccViewStudent: "/class-cc/view-student-record",
  ccViewMentor: "/class-cc/view-mentor-record",
};

export default allRoutes;
